import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "arrow-right-rectangle-17", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 17", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" },
        React.createElement("path", { d: "M3.5 6.5V5A2.5 2.5 0 0 1 6 2.5h5A2.5 2.5 0 0 1 13.5 5v7a2.5 2.5 0 0 1-2.5 2.5H6A2.5 2.5 0 0 1 3.5 12v-1.5h0m-2-2h8" }),
        React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "m7.5 6.75 2 1.75-2 1.75z" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
